/**
 * Agentic status icon tones — aligned with design-system/docs/philosophy.md.
 * Indigo for active/running; muted green for success; red/amber for error/pending.
 */
export const AGENTIC_STATUS_ICON = {
  running: "text-indigo-600 dark:text-indigo-400",
  success: "text-green-700 dark:text-green-500",
  error: "text-red-600 dark:text-red-400",
  pending: "text-amber-700 dark:text-amber-400",
  cancelled: "text-slate-500 dark:text-slate-400",
} as const;
